import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/commons/app-constants';
import { AiQuickSearchGuess } from './quick-search-parser';

export interface AiQuickSearchResponse extends AiQuickSearchGuess {
  creditsUsedThisCall: number;
  creditsUsedTotal: number;
  /** -1 = unlimited. */
  creditsTotal: number;
  /** null when creditsTotal is unlimited. */
  usagePct: number | null;
}

/** Quick Search's "Ask AI" mode (Mill Command Center plan, §F/§H) — Forest-tier only. Translates
 *  loose text into raw field guesses; resolving those against real data still happens locally
 *  via resolveAiGuess(), same fuzzy pipeline a typed query uses. */
@Injectable({ providedIn: 'root' })
export class AiQuickSearchService {
  private base = `${AppConstants.API_URL}api/v1/ai`;

  constructor(private http: HttpClient) {}

  parse(text: string): Observable<AiQuickSearchResponse> {
    return this.http.post<AiQuickSearchResponse>(`${this.base}/quick-search-parse`, { text });
  }
}
